export class StreetAddress {
  line1: string;
  line2: string;
  city: string;
  stateProvCode: string;
  postalCode: string;
}

export interface ICustomAddress {
  customLine1: string;
  customLine2: string;
  customCity: string;
  customStateProvCode: string;
  customPostalCode: string;
}
